module.exports = __webpack_public_path__ + "img/reg_ture.c3336a4d.png";